import React, { useEffect, useRef, useState } from 'react';
import '../css/button.css';
import { Navigate } from 'react-router-dom';
import anime, { set } from 'animejs';
import FramePlayer from '../utils/FramePlayer';
import HomeButton from '../utils/HomeButton';

const Compas = (props) => {

    const [scene, setScene] = useState(0);
    const [playing, setPlaying] = useState(true);
    const [frameNumber, setCurrentFrame] = useState(1);
    const frameNumberRef = useRef(frameNumber);
    const playingRef = useRef(playing);

    const [audio_arr,] = useState(new Audio(process.env.PUBLIC_URL + '/assets/sounds/compas_arr.mp3'));
    const [audio_sol,] = useState(new Audio(process.env.PUBLIC_URL + '/assets/sounds/compas_sol.mp3'));
    const [audio_double,] = useState(new Audio(process.env.PUBLIC_URL + '/assets/sounds/compas_double.mp3'));

    const [isArrPlaying, setIsArrPlaying] = useState(false);
    const [isSolPlaying, setIsSolPlaying] = useState(false);
    const [isDoublePlaying, setIsDoublePlaying] = useState(false);
    const isArrPlayingRef = useRef(isArrPlaying);
    const isSolPlayingRef = useRef(isSolPlaying);
    const isDoublePlayingRef = useRef(isDoublePlaying);

    const nbOfFrames = 85;
    const musicDurationArr = 5.6;
    const musicDurationSol = 7.158;
    const fpsArr = nbOfFrames / musicDurationArr;
    const fpsSol = nbOfFrames / musicDurationSol;

    const clearAllTimeouts = () => {
        let id = window.setTimeout(null, 0);
        while (id--) {
            window.clearTimeout(id);
        }
    }

    const playFrame = () => {
        if (playing.current === false) return;
        if (frameNumberRef.current < nbOfFrames) {
            frameNumberRef.current = frameNumberRef.current + 1;
            setCurrentFrame(frameNumberRef.current);
            let fps = isSolPlayingRef.current ? fpsSol : fpsArr;
            console.log(fps);
            console.log(isSolPlayingRef.current);
            setTimeout(() => {
                playFrame();
            }, (1 / fps) * 1000);
        } else {
            frameNumberRef.current = nbOfFrames;
            setCurrentFrame(frameNumberRef.current);
            playingRef.current = false;
            setPlaying(playingRef.current);
        }
    }

    const playAnim = () => {
        clearAllTimeouts();
        playingRef.current = true;
        setPlaying(playingRef.current);
        frameNumberRef.current = 1;
        setCurrentFrame(frameNumberRef.current);
        playFrame();
    }

    const resetAllMusic = () => {
        audio_arr.pause();
        audio_arr.currentTime = 0;
        audio_sol.pause();
        audio_sol.currentTime = 0;
        audio_double.pause();
        audio_double.currentTime = 0;
    }

    const playMusic1 = () => {
        if (audio_arr.currentTime > 0) {
            setIsArrPlaying(false);
            setIsDoublePlaying(true);
            setIsSolPlaying(false);
            isArrPlayingRef.current = false;
            isDoublePlayingRef.current = true;
            isSolPlayingRef.current = false;
            resetAllMusic();
            audio_double.currentTime = 0;
            audio_double.play();
            playAnim();
        } else {
            setIsArrPlaying(false);
            setIsDoublePlaying(false);
            setIsSolPlaying(true);
            isArrPlayingRef.current = false;
            isDoublePlayingRef.current = false;
            isSolPlayingRef.current = true;
            resetAllMusic();
            audio_sol.currentTime = 0;
            audio_sol.play();
            playAnim();
        }
    }

    const playMusic2 = () => {
        setIsArrPlaying(true);
        setIsDoublePlaying(false);
        setIsSolPlaying(false);
        isArrPlayingRef.current = true;
        isDoublePlayingRef.current = false;
        isSolPlayingRef.current = false;
        resetAllMusic();
        audio_arr.currentTime = 0;
        audio_arr.play();
        playAnim();
    }

    function clearAll() {
        // Get a reference to the last interval + 1
        const interval_id = window.setInterval(function () { }, Number.MAX_SAFE_INTEGER);

        // Clear any timeout/interval up to that id
        for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
        }

        props.audio.forEach(audio => audio.pause());
    }

    useEffect(() => {
        clearAll();

        props.audio.push(audio_arr);
        props.audio.push(audio_sol);
        props.audio.push(audio_double);

    }, []);

    return (
        <>
            <HomeButton />
            <div
                className='background'
                style={{
                    backgroundColor: 'black',
                }}
            />
            {/* vue d'ensemble */}
            <div
                style={{
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    width: '100%',
                    height: '100%',
                    display: scene === 0 ? 'block' : 'none',
                }}
            >
                <img src={process.env.PUBLIC_URL + '/assets/images/compas/1.jpg'}
                    style={{
                        position: 'absolute',
                        top: '25px',
                        left: '30px',
                        width: '600px',
                    }}
                    alt="guitare" />
                <img src={process.env.PUBLIC_URL + '/assets/images/compas/3.jpg'}
                    style={{
                        position: 'absolute',
                        top: '155px',
                        left: '568px',
                        cursor: 'pointer',
                    }}
                    onClick={() => setScene(1)}
                    alt="button" />
                <div
                    style={{
                        position: 'absolute',
                        top: '148px',
                        left: '449px',
                        width: '26px',
                        height: '26px',
                        borderRadius: '15px',
                        backgroundColor: 'transparent',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        //play audio
                        const audio = new Audio(process.env.PUBLIC_URL + '/assets/sounds/compas_double.mp3');
                        audio.play();
                    }}
                />
            </div>

            {/* vue de la partition */}
            <div
                style={{
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    width: '100%',
                    height: '100%',
                    display: scene === 1 ? 'block' : 'none',
                }}
            >
                <img src={process.env.PUBLIC_URL + '/assets/images/compas/12.jpg'}
                    style={{
                        position: 'absolute',
                        top: '25px',
                        left: '30px',
                        width: '600px',
                    }}
                    alt="guitare" />
                <div
                    style={{
                        position: 'absolute',
                        top: '220px',
                        left: '154px',
                        width: '460px'
                    }}
                >
                    <img src={process.env.PUBLIC_URL + `/assets/frames/compas/${frameNumberRef.current}.png`}
                        style={{
                            width: '100%',
                        }}
                    />
                </div>
                <img src={process.env.PUBLIC_URL + '/assets/images/compas/10.jpg'}
                    style={{
                        position: 'absolute',
                        top: '77px',
                        left: '491px',
                        width: '23px',
                        cursor: 'pointer',
                    }}
                    onClick={playMusic2}
                />
                <img src={process.env.PUBLIC_URL + '/assets/images/compas/14.jpg'}
                    style={{
                        position: 'absolute',
                        top: '77px',
                        left: '288px',
                        width: '23px',
                        cursor: 'pointer',
                    }}
                    onClick={playMusic1}
                />
                <p
                    style={{
                        position: 'absolute',
                        top: '438px',
                        left: '518px',
                        cursor: 'pointer',
                        color: 'white',
                    }}
                    onClick={() => setScene(0)}
                >
                    Vue d'ensemble
                </p>
            </div>


        </>

    );
}

export default Compas;
